import { render } from "./btn-card-action.vue?vue&type=template&id=6d4d3ece"
import script from "./btn-card-action.js?vue&type=script&lang=js&external"
export * from "./btn-card-action.js?vue&type=script&lang=js&external"

import "./btn-card-action.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__